const CONFIG = {
  pending_guarantor: { label: 'Pending Guarantor', dot: 'bg-amber-500',  cls: 'badge badge-warning' },
  pending_admin:     { label: 'Under Review',       dot: 'bg-stripe-blue', cls: 'badge badge-info' },
  approved:          { label: 'Approved',            dot: 'bg-green-500',  cls: 'badge badge-success' },
  rejected:          { label: 'Rejected',            dot: 'bg-red-500',    cls: 'badge badge-danger' },
  pending:           { label: 'Pending',             dot: 'bg-amber-500',  cls: 'badge badge-warning' },
  paid:              { label: 'Paid',                dot: 'bg-green-500',  cls: 'badge badge-success' },
};

export default function StatusBadge({ status }) {
  const cfg = CONFIG[status] || { label: status, dot: 'bg-stripe-slate', cls: 'badge badge-neutral' };
  return (
    <span className={cfg.cls}>
      <span className={`w-1.5 h-1.5 rounded-full ${cfg.dot}`} />
      {cfg.label}
    </span>
  );
}
